<template>
	<div class="content">
		
		<div class="info">
			<div class="backgo" @click="back()"><img src="../../assets/img/back.png" alt=""><div>返回</div></div>
			<div class="cont_title">答题情况详情</div>
			<div class="info_title">实训答题</div>
			<div class="wrap">
				<div class="left">
					<div class="left_title">一、单选题</div>
					<div class="left_item" v-for="(item,index) in shiti.danxuan" :key="index+'d'">
						<div class="left_item_title">{{Number(index)+1}}、{{item.question_title}}</div>
						<div class="left_item_btm">
							<div class="left_item_btm_item" :class="ite.is_xuanzhong == 1?'left_item_btm_itemac':''" 
							v-for="ite in item.oprtion">{{ite.option_sn}}、{{ite.option_title}}</div>
						</div>
						<div class="left_item_btm">
							<div class="left_item_btm_item left_item_btm_itemhh" >正确答案：{{item.zhengque}}</div>
						</div>
					</div>
					
					<div class="left_title" style="margin-top: 50px;">二、多选题</div>
					<div class="left_item" v-for="(item,index) in shiti.duoxuan" :key="index+'c'">
						<div class="left_item_title">{{Number(index)+1}}、{{item.question_title}}</div>
						<div class="left_item_btm">
							<div class="left_item_btm_item" :class="ite.is_xuanzhong == 1?'left_item_btm_itemac':''" 
							v-for="ite in item.oprtion">{{ite.option_sn}}、{{ite.option_title}}</div>
						</div>
						<div class="left_item_btm">
							<div class="left_item_btm_item left_item_btm_itemhh" >正确答案：{{item.zhengque}}</div>
						</div>
					</div>
					
					<div class="left_title" style="margin-top: 50px;">三、判断题</div>
					<div class="left_item" v-for="(item,index) in shiti.panduan" :key="index+'b'">
						<div class="left_item_title">{{Number(index)+1}}、{{item.question_title}}</div>
						<div class="left_item_btm">
							<div class="left_item_btm_item" :class="ite.is_xuanzhong == 1?'left_item_btm_itemac':''" 
							v-for="ite in item.oprtion">{{ite.option_sn}}、{{ite.option_title}}</div>
						</div>
						<div class="left_item_btm">
							<div class="left_item_btm_item left_item_btm_itemhh" >正确答案：{{item.zhengque}}</div>
						</div>
					</div>
					
					<div class="left_title" style="margin-top: 50px;">四、简答题</div>
					<div class="left_item" v-for="(item,index) in shiti.yingyong" :key="index+'a'">
						<div class="left_item_title">{{Number(index)+1}}、{{item.question_title}}</div>
						<el-input style="margin-top: 20px;" v-model="item.answer" readonly type="textarea" clearable :rows="6"/>
						<div class="left_item_btm">
							<div class="left_item_btm_item left_item_btm_itemhh" >正确答案：</div>
						</div>
						<el-input style="margin-top: 20px;" v-model="item.zhengque_answer" readonly type="textarea" clearable :rows="6"/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import {task_question_details} from "../../api/new.js";	
	export default {
		data() {
			return {
				shiti:'',
			};
		},
		mounted() {
			if(this.$route.query.id){
				this.info(this.$route.query.id)
			}
		},
		methods: {
			//列表
			info(id){
				var _this = this
				var data = {id:id}
				task_question_details(data).then((res) => {
					if (res.code == 0) {
						this.shiti = res.data
					} else {
						this.$message.error(res.msg);
					} 
				})
			},
			back(){
				this.$router.go(-1);
			}
		},
	};
</script>
<style lang="less" scoped>
div{
	box-sizing: border-box;
}
.content{
	width: 100%;
	min-width: 1200px;
	margin: 0 auto;
	.info{
		width: 100%;
		background: #FFFFFF;
		border-radius: 20px;
		padding: 40px 100px 40px 50px;	
		.info_title{
			width: 100%;
			font-size: 30px;
			font-weight: 500;
			color: #333333;
			font-weight: bold;
			line-height: 30px;
			text-align: center;
		}
		.wrap{
			width: 100%;
			display: flex;
			justify-content: space-between;
			margin-top: 40px;
			.left{
				flex: 1;
				.left_title{
					width: 100%;
					font-size: 18px;
					font-weight: 500;
					color: #333333;
					line-height: 36px;
				}
				.left_item{
					width: 100%;
					margin-top: 20px;
					.left_item_title{
						width: 100%;
						font-size: 18px;
						font-weight: 500;
						color: #333333;
						line-height: 36px;
					}
					.left_item_btm{
						width: 80%;
						display: flex;
						flex-wrap: wrap;
						padding-left: 25px;
						.left_item_btm_item{
							margin-top: 15px;
							margin-right: 25px;
							font-size: 18px;
						}
						.left_item_btm_itemac{
							color: #007AFF;
						}
						.left_item_btm_itemhh{
							color: #E13049;
						}
					}
					
				}
				
			}
			.right{
				width: 265px;
				margin-left: 80px;
				.right_title{
					font-size: 20px;
					font-weight: bold;
					color: #333333;
					line-height: 20px;
				}
				.right_title1{
					font-size: 18px;
					font-weight: 500;
					color: #333333;
					line-height: 18px;
					margin-top: 18px;
				}
				.right_box{
					width: 100%;
					display: flex;
					flex-wrap: wrap;
					.right_box_item{
						width: 38px;
						height: 38px;
						border: 2px solid #CCCCCC;
						border-radius: 50%;
						font-size: 20px;
						color: #666666;
						line-height: 34px;
						text-align: center;
						margin-top: 13px;
						margin-right: 17px;
						cursor: default;
					}
					.right_box_item:nth-child(5n+5){
						margin-right: 0;
					}
				}
				.status{
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding: 26px 0;
					margin-top: 26px;
					border-top: 1px solid #E6E6E6;
					.status_item{
						display: flex;
						align-items: center;
						cursor: default;
						.status_item_dian{
							width: 20px;
							height: 20px;
							background: #40D497;
							border-radius: 50%;
							margin-right: 10px;
						}
						.status_item_dian1{
							width: 20px;
							height: 20px;
							background: #D8D8D8;
							border-radius: 50%;
							margin-right: 10px;
						}
						.status_item_title{
							font-size: 20px;
							font-weight: 500;
							color: #656565;
							line-height: 20px;
						}
					}
				}
				.submit{
					width: 100%;
					height: 56px;
					background: #007AFF;
					border-radius: 28px;
					font-size: 20px;
					font-weight: 500;
					color: #FFFFFF;
					line-height: 56px;
					text-align: center;
					cursor: pointer;
					margin-top: 20px;
				}
				.submit:hover{
					opacity: 0.7;
				}
				.submit:active{
					opacity: 0.9;
				}
			}
			
		}
	
	
	
	}
	.el-radio {
		margin-top: 15px;
		margin-left: 15px;
	}
	.el-checkbox{
		margin-top: 15px;
		margin-left: 15px;
	}
}	
</style>



// WEBPACK FOOTER //
// src/components/zuoye/zuoDatiDetail.vue